/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const bulkImportTmdbSummarySchema = z.object({
  processed: z.number(),
  imported: z.number(),
  unmatched: z.number(),
  failed: z.number(),
  nextCursor: z.number().nullable(),
});

export type IBulkImportTmdbSummary = z.infer<typeof bulkImportTmdbSummarySchema>;

export const bulkImportTmdbResponseSchema = createApiResponseSchema(
  bulkImportTmdbSummarySchema,
) as import('zod').ZodSchema<IAPI<IBulkImportTmdbSummary>>;

export type IBulkImportTmdbResponse = IAPI<IBulkImportTmdbSummary>;
